import React, { Component } from "react";
import Footer from "../../Layout/Footer2";
import Header from "../../Layout/Header";
import { Helmet } from 'react-helmet';
import api from '../Api';

import { Link } from "react-router-dom";
import ContentJobs from '../../Element/ContentJobs';
import Jobfindbox from "../../Element/Jobfindbox2";

const axios = require('axios');

class JobsInAustin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobs: [],
            total: '',
            isLoading: true
        };
    }

    componentDidMount() {
        this.getJobs();
    }

    getJobs() {
        axios
            .request(api.getJobs('', 'Austin'))
            .then((response) => {
                this.setState({
                    jobs: response.data.jobs,
                    total: response.data.pagesInfo.totalJobs,
                    pages: response.data.pagesInfo.totalpages,
                    page: response.data.pagesInfo.page,
                    perPage: response.data.pagesInfo.perPage,
                    prevPage: response.data.pagesInfo.prevPage,
                    nextPage: response.data.pagesInfo.nextPage,
                    isLoading: false
                });
            })
            .catch((error) => {
                console.error(error);
                this.setState({ isLoading: false });
            });
    }

    render() {
        let { jobs, total, page, pages, prevPage, nextPage, isLoading } = this.state;

        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Remote Jobs in Austin: Find Top Work Opportunities | OpenToWorkRemote</title>
                    <meta name="description" content="Browse remote jobs in Austin. Find top work-from-home opportunities with leading American companies across Austin. Apply today!" />
                    <link rel="canonical" href="https://www.opentoworkremote.com/jobs-in-austin" />
                </Helmet>

                <div className="page-content bg-white">
                    <div className="page-content bg-white">
                        <div className="dez-bnr-inr bg-dark">
                            <div className="container">
                                <div className="dez-bnr-inr-entry">
                                    <Link to={""}>
                                        <h1 className="text-white">
                                            Find jobs in Austin
                                        </h1>
                                    </Link>
                                    <div className="breadcrumb-row">
                                        <ul className="">
                                            <li>Career opportunities in Austin</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Jobfindbox myLocation="Austin" />

                    </div>
                    <ContentJobs
                        jobs={jobs}
                        total={total}
                        page={page}
                        pages={pages}
                        prevPage={prevPage}
                        nextPage={nextPage}
                        isLoading={isLoading}
                    />

                    <div className="section-full bg-white p-t50 p-b20">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 section-head text-center">
                                    <h2 className="m-b5">Frequently Asked Questions About Remote Jobs in Austin</h2>
                                    <p>Common questions about remote work opportunities in Austin's tech ecosystem</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 m-b30">
                                    <div className="icon-bx-wraper p-a30 center bg-gray radius-sm">
                                        <h4 className="dez-title m-b15">What makes Austin unique for remote work opportunities?</h4>
                                        <p>Austin's unique ecosystem combines the prestigious University of Texas at Austin, a thriving tech sector known as "Silicon Hills," and a vibrant startup scene. Remote workers benefit from access to Austin's innovation economy while enjoying a lower cost of living compared to other major tech hubs. The area's focus on technology, healthcare, and creative industries creates diverse remote opportunities. Many Austin-based companies offer hybrid work models, allowing professionals to combine remote work with occasional in-person collaboration in one of America's fastest-growing tech hubs.</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 m-b30">
                                    <div className="icon-bx-wraper p-a30 center bg-gray radius-sm">
                                        <h4 className="dez-title m-b15">What are the most in-demand remote jobs in Austin's market?</h4>
                                        <p>Austin's job market particularly values software engineers, especially in cloud computing and artificial intelligence. The presence of major tech companies like Dell, IBM, and Oracle creates strong demand for enterprise software expertise. Cybersecurity roles are abundant, given the city's growing tech sector. There's also significant demand for data scientists, product managers, and UX/UI designers. The creative technology sector, including gaming and digital media, offers numerous remote opportunities in content creation and interactive design.</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 m-b30">
                                    <div className="icon-bx-wraper p-a30 center bg-gray radius-sm">
                                        <h4 className="dez-title m-b15">What salary ranges can remote workers expect in Austin?</h4>
                                        <p>Remote workers in Austin-based companies typically enjoy competitive compensation reflecting the region's tech focus. Senior software engineers often command salaries ranging from $110,000 to $170,000+. Product managers and data scientists can expect ranges from $95,000 to $150,000. UX/UI designers might see ranges from $85,000 to $140,000. While remote workers might receive slightly adjusted salaries based on their location, Austin companies often offer comprehensive benefits packages including health insurance, equity compensation, and professional development allowances.</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 m-b30">
                                    <div className="icon-bx-wraper p-a30 center bg-gray radius-sm">
                                        <h4 className="dez-title m-b15">How can professionals network in Austin's remote work environment?</h4>
                                        <p>Despite working remotely, professionals can connect with Austin's tech community through virtual meetups, online tech forums, and industry-specific Slack channels. Organizations like Austin Tech Alliance and Austin Digital Jobs offer virtual networking events. Many Austin startups host virtual lunch-and-learns and technical workshops. LinkedIn groups focused on Austin's tech scene provide valuable connections. Additionally, participating in online communities centered around specific technologies or industries prevalent in Austin (like cloud computing or gaming) can lead to job opportunities and professional growth.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />

                <Helmet>
                    <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                                {
                                    "@type": "Question",
                                    "name": "What makes Austin unique for remote work opportunities?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Austin's unique ecosystem combines the prestigious University of Texas at Austin, a thriving tech sector known as 'Silicon Hills,' and a vibrant startup scene. Remote workers benefit from access to Austin's innovation economy while enjoying a lower cost of living compared to other major tech hubs. The area's focus on technology, healthcare, and creative industries creates diverse remote opportunities. Many Austin-based companies offer hybrid work models, allowing professionals to combine remote work with occasional in-person collaboration in one of America's fastest-growing tech hubs."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "What are the most in-demand remote jobs in Austin's market?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Austin's job market particularly values software engineers, especially in cloud computing and artificial intelligence. The presence of major tech companies like Dell, IBM, and Oracle creates strong demand for enterprise software expertise. Cybersecurity roles are abundant, given the city's growing tech sector. There's also significant demand for data scientists, product managers, and UX/UI designers. The creative technology sector, including gaming and digital media, offers numerous remote opportunities in content creation and interactive design."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "What salary ranges can remote workers expect in Austin?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Remote workers in Austin-based companies typically enjoy competitive compensation reflecting the region's tech focus. Senior software engineers often command salaries ranging from $110,000 to $170,000+. Product managers and data scientists can expect ranges from $95,000 to $150,000. UX/UI designers might see ranges from $85,000 to $140,000. While remote workers might receive slightly adjusted salaries based on their location, Austin companies often offer comprehensive benefits packages including health insurance, equity compensation, and professional development allowances."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "How can professionals network in Austin's remote work environment?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Despite working remotely, professionals can connect with Austin's tech community through virtual meetups, online tech forums, and industry-specific Slack channels. Organizations like Austin Tech Alliance and Austin Digital Jobs offer virtual networking events. Many Austin startups host virtual lunch-and-learns and technical workshops. LinkedIn groups focused on Austin's tech scene provide valuable connections. Additionally, participating in online communities centered around specific technologies or industries prevalent in Austin (like cloud computing or gaming) can lead to job opportunities and professional growth."
                                    }
                                }
                            ]
                        }
                    `}
                    </script>
                </Helmet>
            </div>
        );
    }
}

export default JobsInAustin;
